'use strict';

var hoverintent = require('hoverintent');
var Constants = require('../constants/constants');
var Utils = require('../utils/utils');

// Constructor
var Popover = function() {

  var self = this;

  self.config = {
    'button'        :  $('[data-show-popover]'),
    'popover'       :  $('[data-popover]'),
    'stickyParent'  :  $('[data-sticky-element]')
  }

  self.parseButtons = function($button) {
    $button.each(function() {
      var $this = $(this);
      var $popover = $($this.attr('data-show-popover'));
      var $stickyParent;

      $this.parents().each(function() {
        var $parent = $(this);

        if ($parent[0].hasAttribute('data-sticky-element')) {
          $stickyParent = $parent;
          return false;
        }
      });

      if ($this[0].hasAttribute('data-show-popover-on-breakpoint')) {
        var breakpointName = $this.attr('data-show-popover-on-breakpoint').toUpperCase();
        self.viewportHandler($this, $popover, $stickyParent, breakpointName);
      } else {
        self.hoverHandler($this, $stickyParent, $popover);
        self.focusHandler($this, $stickyParent, $popover);
      }
    });
  }

  self.viewportHandler = function($button, $popover, $stickyParent, breakpointName) {

    var largeViewports = function() {
      self.hoverHandler($button, $popover, $stickyParent);
      self.focusHandler($button, $popover, $stickyParent);
    };

    var smallViewports = function() {
      self.destroy();
    };

    new Utils().matchmediaHandler(breakpointName, largeViewports, smallViewports);
  }

  self.hoverHandler = function($button, $popover, $stickyParent) {

    var button = $button[0];
    var popoverParent = $popover.parent()[0];
    var mq = new Constants().MEDIA_QUERIES.MEDIUM;
    var mql = window.matchMedia(mq);
    var hoverIn = hoverintent(button, function() {
      self.showPopover($button, $popover, $stickyParent);
    }, function() {});
    var hoverOut = hoverintent(popoverParent, function() {}, function() {
      self.hidePopover($button, $popover, $stickyParent);
    });

    // Remove hoverintent listeners
    var mediaQueryHandler = function(mql) {

      if (! mql.matches) {
        hoverIn.remove();
        hoverOut.remove();
      }
    };

    mql.addListener(mediaQueryHandler);
    mediaQueryHandler(mql);
  }

  self.focusHandler = function($button, $popover, $stickyParent) {
    $button
      .on('focus.popover', function() {
        self.showPopover($button, $popover, $stickyParent);
      })
      .on('blur.popover', function() {
        self.hidePopover($button, $popover, $stickyParent);
      });
  }

  self.showPopover = function($button, $popover, $stickyParent) {

    self.hideOtherPopovers($button, $popover, $stickyParent);

    if (! $popover.hasClass('is-visible') && ! $popover.hasClass('velocity-animating')) {

      if ($stickyParent) {
        self.increaseStickyZindex.on($stickyParent);
      }

      $button.addClass('is-active');
      $popover
        .addClass('is-visible')
        .velocity({
          opacity: 1,
          translateY: [0, '-2rem'],
          scale: [1, 0.9]
        },{
          display: 'block',
          easing: 'easeOutQuart',
          duration: 250
        });
    }
  }

  self.hidePopover = function($button, $popover, $stickyParent) {

    if ($popover.hasClass('is-visible') && ! $popover.hasClass('velocity-animating')) {

      if ($stickyParent) {
        self.increaseStickyZindex.off($stickyParent);
      }

      $button.removeClass('is-active');
      $popover
        .removeClass('is-visible')
        .velocity({
          opacity: 0,
          translateY: ['-2rem', 0],
          scale: [0.9, 1]
        },{
          display: 'none',
          duration: 150
        });
    }
  }

  self.hideOtherPopovers = function($currentButton, $currentPopover, $currStickyParent) {
    var $popover = self.config.popover.not($currentPopover);
    var $button = self.config.button.not($currentButton);
    var $stickyParent = self.config.stickyParent.not($currStickyParent);
    if ($popover.hasClass('is-visible')) {
      self.hidePopover($button, $popover, $stickyParent);
    }
  }

  self.increaseStickyZindex = {
    on: function($stickyParent) {
      $stickyParent.css('z-index', '2');
    },
    off: function($stickyParent) {
      $stickyParent.removeAttr('style');
    }
  }

  self.destroy = function() {
    self.config.popover
      .removeClass('is-visible')
      .removeAttr('style');
    self.config.button
      .removeClass('is-active')
      .off('focus.popover blur.popover');
    self.config.stickyParent
      .removeAttr('style');
  }

  self.init = function() {
    self.parseButtons(self.config.button);
  }
};

module.exports = Popover;
